import React from "react";
import "./style.css";
// import Logo from '../../Assets/logo.png'
import Logo from "../../AssetsNew/HPLogo-LoadingPage.svg";

const StartScreen = () => {
  return (
    <div className="startscreen_con">
      <div>
        <img className="animated-icon" src={Logo} width={320} height={100} />
      </div>
    </div>
  );
};

export default StartScreen;
